import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import RenameEventDocForm from 'components/event/FileSystem/RenameEventDocForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';
import { UPDATE_EVENT_DOC } from 'actions/Types';
import { updateEventDoc } from 'actions/Event';
import { clearModal } from 'actions';
import createModalConnector from './createModalConnector';

const RenameEventDocModal = (props) => {
  const { modalOpen, updateEventDoc, clearModal, name, eventDocId } = props;

  const clearRenameEventDocModal = clearModal.bind(null, UPDATE_EVENT_DOC);

  return (
    <Modal isOpen={modalOpen} toggle={clearRenameEventDocModal}>
      <StyledModalHeader toggle={clearRenameEventDocModal}>
        Edit file
      </StyledModalHeader>
      <StyledModalBody>
        {eventDocId && (
          <RenameEventDocForm
            name={name}
            eventDocId={eventDocId}
            onSubmit={updateEventDoc.bind(null, eventDocId)}
            onCancel={clearRenameEventDocModal}
          />
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default connect(createModalConnector(UPDATE_EVENT_DOC), {
  clearModal,
  updateEventDoc,
})(RenameEventDocModal);
